export const memoizeWeak: <F extends (...args: any[]) => any>(f: F) => F = require('memoizee/weak');
